module.exports = __webpack_public_path__ + "img/15.6f7a5dfc.jpg";